import _get from 'lodash/get';
import { StringColumn, CategoricalColumn } from 'baseui/data-table';

export const COL_NAMES = {
	userName: 'name',
	email: 'email',
	phoneNo: 'phone',
	department: 'department',
	manager: 'manager',
	designation: 'designation',
	team: 'team',
	updatedBy: 'updatedBy'
};

export const columnConfigs = [
	StringColumn({
		title: 'User Name',
		mapDataToValue: (data: any) => {
			return String(_get(data, COL_NAMES.userName, 'NA'));
		}
	}),
	StringColumn({
		title: 'Email ID',
		mapDataToValue: (data: any) => {
			return String(_get(data, COL_NAMES.email, 'NA'));
		}
	}),
	StringColumn({
		title: 'Phone No.',
		mapDataToValue: (data: any) => {
			return String(_get(data, COL_NAMES.phoneNo, 'NA'));
		}
	}),
	CategoricalColumn({
		title: 'Deparment Name',
		mapDataToValue: (data: any) => {
			return String(_get(data, COL_NAMES.department, 'NA'));
		}
	}),
	CategoricalColumn({
		title: 'Manager Name',
		mapDataToValue: (data: any) => {
			return String(_get(data, COL_NAMES.manager, 'NA'));
		}
	}),
	CategoricalColumn({
		title: 'Designation',
		mapDataToValue: (data: any) => {
			return String(_get(data, COL_NAMES.designation, 'NA'));
		}
	}),
	CategoricalColumn({
		title: 'POD/Team',
		mapDataToValue: (data: any) => {
			return String(_get(data, COL_NAMES.team, 'NA'));
		}
	}),
	StringColumn({
		title: 'Updated By',
		mapDataToValue: (data: any) => {
			return String(_get(data, COL_NAMES.updatedBy, 'NA'));
		}
	})
];

export default { columnConfigs, COL_NAMES };
